export const storageTypes = {
    LOCAL_STORAGE: 'localStorage',
    SESSION_STORAGE: 'sessionStorage'
}